<template>
	<div class="interaction-information">
    <div v-show="!monograph.data.Id">
      <p>{{loadingText}}</p>
    </div>

    <div v-if="monograph.data.Id" class="monograph">
      <h5 class="title">{{ monograph.data.Title }}</h5>

      <div class="info">
        <h6 id="severity_level">{{severityLevelText}}</h6>
        <p>{{ monograph.data.SeverityLevel || emptyText }}</p>

        <h6 id="mechanism">{{mechanismOfActionText}}</h6>
        <p>{{ monograph.data.Mechanism || emptyText }}</p>

        <h6 id="clinical_effects">{{clinicalEffectsText}}</h6>
        <p>{{ monograph.data.ClinicalEffects || emptyText }}</p>

        <h6 id="predisposing_factors">{{predisposingFactorsText}}</h6>
        <p>{{ monograph.data.PredisposingFactors || emptyText }}</p>

        <h6 id="patient_management">{{patientManagementText}}</h6>
        <p>{{ monograph.data.PatientManagement || emptyText }}</p>

        <h6 id="discussion">{{discussionText}}</h6>
        <p>{{ monograph.data.Discussion || emptyText }}</p>

        <!--<h6 id="references">References</h6>
        <p>{{ monograph.data.References || emptyText }}</p>-->
      </div>
    </div>
      
	</div>
</template>

<script>
import InteractionMonograph from "../models/InteractionMonograph.js";

export default {
    props: [
        "interactionId"
    ],
    data: function () {
        console.log("HERE", this);
        return {
            emptyText: "",
            severityLevelText: "",
            mechanismOfActionText: "",
            clinicalEffectsText: "",
            predisposingFactorsText: "",
            patientManagementText: "",
            discussionText: "",
            emptyText: "",
            loadingText: ""
        };
	},
    computed: {
        message: function () {
            return this.getDefault("message").replace("${interaction_id}", this.interactionId);
        }
    },
    asyncComputed: {
        monograph: {
            get: function () {
                console.log('asyncComputed');
                return InteractionMonograph.get(this.interactionId);
            },
            default: {
                data: {}
            }
        }
    },
    created: function () {
        this.loadDefaults();
    },
    methods: {
        loadDefaults: function () {
            var me = this;

            Default.GetForView("interaction").then(function (res) {
                me.defaults = res.data;
                me.loadText();
            });
        },
        getDefault: function (nameKey) {
            return Default.Find(nameKey, this.defaults);
        },
        loadText: function () {
            this.severityLevelText = this.getDefault("severity_level");
            this.mechanismOfActionText = this.getDefault("mechanism_of_action");
            this.clinicalEffectsText = this.getDefault("clinical_effects");
            this.predisposingFactorsText = this.getDefault("predisposing_factors");
            this.patientManagementText = this.getDefault("patient_management");
            this.discussionText = this.getDefault("discussion");
            this.emptyText = this.getDefault("none");
            this.loadingText = this.getDefault("loading");
        }
    }
};
</script>



// WEBPACK FOOTER //
// InteractionInformation.vue?6aa2fb87